import { z } from "zod/mini";
import { type Table } from "dexie";

export const DatabasePropertiesSchema = {
	id: z.string(),
	createdAt: z.iso.datetime({ offset: true }),
	updatedAt: z.iso.datetime({ offset: true }),
};

export type DatabaseProperties = {
	[K in keyof typeof DatabasePropertiesSchema]: z.infer<
		(typeof DatabasePropertiesSchema)[K]
	>;
};

export type EntityDatabaseType<T extends DatabaseProperties, K> = Table<
	T,
	K,
	T
>;
